<template>
    <div class="thank-you-pro-container xero-wrap xero-wrap-mobile sr-cover-image">
        <div class="d-flex justify-content-center m-top-5rem m-bottom-3rem">
            <img src="static/img/peiso-logo.svg" class="object-fit-center" height="50" alt="">
        </div>
        <div class="content m-top-2rem">
            <h1 class="text-center">
                Thank you for subscribing to Peiso Pro!
            </h1>

            <div class="welcome-content text-center">
                <div class="m-bottom-3rem m-top-2rem">
                    Step 1 in transforming your business is complete!
                </div>

                <div class="m-bottom-3rem">
                    <!-- Don't worry,  -->
                    Next step (2) book your account setup call via sending an email to <a href="mailto:support@peiso.com.au" class="font-weight-bold pink text-no-decoration">support@peiso.com.au</a>.
                </div>

                <div class="m-bottom-3rem">
                    Use your username and password to login to Peiso and connect your point of sale and scheduling.
                </div>
                
                <div class="support m-bottom-3rem">
                    If you need any assistance, please do not hesitate to contact us at <a href="mailto:support@peiso.com.au" class="font-weight-bold pink text-no-decoration">support@peiso.com.au</a>.

                </div>

                <div class="m-bottom-3rem">
                    Many thanks and enjoy!
                </div>
                
                <div class="m-bottom-3rem font-weight-bold pink">
                    From your Peiso Team!
                </div>
            </div>

            <div class="text-center d-flex justify-content-center">
                <el-button type="peiso-border-button" class="px-2rem py-1rem" @click="redirectToLogin">Login to your Peiso Account Here</el-button>
            </div>

        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    methods: {
        redirectToLogin() {
            window.location.href = `${process.env.WEB_URL}login`;
        }
    }
}
</script>

<style lang="scss">
@import 'static/scss/colors';
@import 'static/scss/fonts/fonts';
    .thank-you-pro-container {
       
        
        .content {
            h1 {
                @include montserrat-font(42px, normal, 700, $pink1);
            }

            .welcome-content {
                @include opensans-font(18px, 1.5, 300, $white);
            }

            .support {
                font-size: 14px;

                > span {
                    color: $pink1;
                }
            }

            .pink {
                color: $pink1;
            }

            a {
                text-decoration: unset;
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/register/thankYouPro.vue